import { WorkspaceSegments } from "../../constants/workspaceSegments.js";

export const guideContentByKey = {
  main: {
    dashboard: {
      title: "Dashboard",
      what: "O Dashboard é o painel de números e gráficos da sua operação. Aqui você vê atendimentos, clientes, vendas e outros resultados do período escolhido — sem precisar abrir conversa por conversa. Não é o extrato de um único cliente nem o cálculo de um programa de parceria.",
      steps: [
        "Selecione as datas que quer analisar no topo",
        "Leia os números principais em cada card",
        "Troque de aba para ver clientes, produtos, vendas, pesquisas ou outros recortes",
        "Use Exportar para baixar a aba atual em planilha. Pesquisas, ao vivo e tarefas da equipe não exportam por aqui",
      ],
      tips: [
        "Compare períodos parecidos — por exemplo, esta semana com a semana passada — para entender se melhorou ou piorou.",
        "Para ver as solicitações de um cliente num dia, filtre a lista de Atendimento. O Dashboard não gera PDF da conversa.",
      ],
    },
    chat: {
      title: "Atendimento",
      what:
        "Central de conversas com três partes: lista de solicitações à esquerda (busca, Meu dia, filtros), conversa no centro (histórico e área de mensagem) e painel de detalhes à direita (cliente, equipe, tarefas). Cada solicitação tem protocolo, responsável, status e canal de origem.",
      steps: [
        "Use Meu dia ou filtros para encontrar solicitações pendentes ou suas",
        "Abra a conversa: leia o histórico e confira responsável e status no topo",
        "Escolha Responder cliente ou Anotação interna na área de mensagem",
        "Altere o status ao encerrar; transfira pelo seletor \"Responsável\" ou @menção se preciso",
        "Use o painel à direita para dados do cliente, tipo de atendimento e tarefas",
      ],
      tips: [
        "No WhatsApp oficial (Meta), observe a janela de 24h — fora dela use modelo de mensagem de reengajamento.",
        "Fixe solicitações importantes pelo menu da linha (botão direito).",
        "Busca avançada e Ver em tabela ajudam quando há muitas solicitações.",
        "Para unificar protocolos, selecione pelo menos dois na busca ou na ficha do cliente e use Unificar. Escolha o protocolo principal, o cliente, o tipo e a origem. As mensagens vão para o principal e os outros protocolos são cancelados. Isso não soma prêmio de parceria.",
        "Várias notas do mesmo cliente continuam sendo várias solicitações. Filtre a lista por cliente. Não há um cartão único de prêmio acumulado.",
        "Na linha do tempo, o filtro Logs de API mostra a requisição e a resposta de um serviço externo. Não é a pergunta do cliente e não vira PDF.",
        "Ver transcrição e Ocultar transcrição só mostram ou escondem o texto já gerado. Não há opção para ativar ou desativar a transcrição de áudio em Configurações. O uso entra nos créditos de IA do workspace. Desligar de vez é ajuste da Xvision, fora do menu.",
        "Mensagem de grupo aparece quando o canal de WhatsApp já participa daquele grupo. Não se cadastra o grupo colando um código no telefone do cliente.",
      ],
    },
    sales_pipeline: {
      title: "Pipeline de Vendas",
      what: "O Pipeline de Vendas é um funil de oportunidades organizado em etapas — como um quadro com colunas. Você vê em que fase está cada negociação e move adiante conforme o cliente avança.",
      steps: [
        "Filtre por responsável, etapa ou período",
        "Abra um card para ver detalhes da oportunidade",
        "Arraste entre colunas quando a venda progredir ou voltar",
      ],
      tips: ["Combine com o time o significado de cada etapa para todos falarem a mesma língua."],
    },
    clients: {
      title: "Clientes",
      what: "Cadastro e histórico das pessoas com quem sua empresa conversa ou vende. Consulte telefone, e-mail, compras anteriores e atendimentos passados. A lista e a ficha não mostram uma coluna Data de criação para explicar a origem do cadastro. Essa data fica no registro e aparece na comparação quando você unifica duplicados.",
      steps: [
        "Busque pelo nome, telefone ou e-mail",
        "Abra o cadastro para ver detalhes e histórico",
        "Na aba Solicitações, marque protocolos para unificar, distribuir, alterar ou exportar — igual à tela de resultados da busca",
        "Para juntar duplicados, selecione dois ou mais cadastros e use unificar. Escolha o cadastro principal, resolva conflitos e confirme",
        "Em relacionamentos, use Vincular relacionamento. Bidirecional aparece dos dois lados. Unidirecional fica só a partir de quem originou o vínculo",
        "Portal do cliente: é preciso existir o canal em Configurações, Canais. Depois selecione os clientes e envie o convite por e-mail",
      ],
      tips: [
        "Dados corretos ajudam na hora de atender — o cliente não precisa repetir tudo de novo.",
        "Unificar clientes junta o cadastro. Unificar solicitações é outra ação: na busca de protocolos ou na aba Solicitações da ficha do cliente, com as mesmas opções de exportar.",
      ],
    },
    surveys: {
      title: "Pesquisas",
      what: "Crie questionários de satisfação ou opinião, envie o link aos clientes e acompanhe quantas pessoas responderam e o que disseram.",
      steps: [
        "Monte ou edite as perguntas da pesquisa",
        "Publique e compartilhe o link com quem deve responder",
        "Acompanhe os resultados na área de análise",
      ],
      tips: ["Perguntas curtas e diretas costumam receber mais respostas."],
    },
    awareness: {
      title: "Níveis de consciência",
      what: "Quadro para organizar atendimentos ou leads por interesse — por exemplo, quem ainda está conhecendo a empresa, quem já demonstrou interesse ou quem está pronto para fechar.",
      steps: [
        "Abra o quadro e veja os cards em cada coluna",
        "Arraste um card quando a relação com o cliente evoluir",
        "Use filtros para focar no que importa hoje",
      ],
      tips: ["Defina com o time o que significa cada coluna para não haver dúvida na hora de mover."],
    },
    products: {
      title: "Produtos",
      what: "Catálogo do que sua empresa vende ou divulga: nome, preço, estoque, fotos e descrições. Alimenta loja, orçamentos e atendimentos que envolvem produtos. O SKU aceita só números (1854537), letras e números (VO24228657) ou hífen simples (12345-ABC), com até 50 caracteres. Espaço, barra, % e hífen duplo não entram, porque a página do produto não abre. O sistema tira espaços no começo e no fim. O mesmo SKU não pode repetir dentro do workspace.",
      steps: [
        "Cadastre ou edite produtos",
        "Informe o SKU com letras, números e hífen simples, desde que ainda não exista naquele workspace",
        "Ajuste preço e disponibilidade",
        "Organize em categorias para facilitar a busca",
        "Exporte a lista de produtos pela ação de exportar desta tela, não pelo Dashboard",
      ],
      tips: ["Comece pelos produtos mais vendidos — eles costumam gerar mais dúvidas no atendimento."],
    },
    campaigns: {
      title: "Campanhas",
      what: "Campanhas montam envio para um público, com canal, mensagem e agendamento. Não são a mesma tela que banners da vitrine e não criam sozinhas um sortimento de produtos.",
      steps: [
        "Abra Campanhas e crie ou escolha a campanha",
        "Defina público, canal, mensagem e quando enviar",
        "Acompanhe o resultado do envio",
        "Se o clique de um banner deve abrir só alguns produtos, o destino do banner precisa apontar para uma categoria ou página que já liste esses produtos",
      ],
      tips: ["Banners ficam em Configurações. Grupos de WhatsApp no público da campanha são os que o canal já enxerga. Não se cadastra um grupo colando um código na ficha do cliente."],
    },
  },
  settings: {
    companies: {
      title: "Empresas",
      what: "Para quem opera mais de uma marca ou filial no mesmo sistema: cadastre cada empresa e controle quem pode acessar qual.",
      steps: [
        "Cadastre ou edite os dados de cada empresa",
        "Ative ou pause quando necessário",
        "Revise quem tem acesso a cada uma",
      ],
    },
    users: {
      title: "Usuários",
      what: "Convide colegas, defina o que cada um pode fazer e mantenha a equipe organizada no sistema. O histórico do usuário mostra data, hora e se foi Login ou Logout. Não mostra se a pessoa entrou por celular ou computador.",
      steps: [
        "Envie convites para novas pessoas",
        "Escolha o cargo ou perfil de cada uma",
        "Revise de tempos em tempos quem ainda precisa de acesso",
        "Abra o histórico do usuário para ver entradas e saídas, sem detalhe de aparelho",
      ],
      tips: ["Dê apenas o acesso necessário — isso evita erros e protege informações sensíveis. A ficha do cliente também não mostra o aparelho usado no login."],
    },
    chatbot: {
      title: "Chatbots",
      what: "Monte atendimentos automáticos com menus e respostas prontas — útil para horário de funcionamento, triagem inicial ou perguntas repetidas. Se um passo de consulta já guarda um resultado numa variável do fluxo, a condição seguinte lê essa mesma variável. Não crie outro nome interno.",
      steps: [
        "Crie um chatbot novo ou edite um existente",
        "Monte o fluxo de perguntas e respostas na tela de edição",
        "Para encaminhar conforme a rota do ônibus (ARTESP, ANTT ou AGEMS), grave o tipo de rota na variável que o fluxo já mostra e use uma condição para transferir ao agente de IA correspondente, pelo responsável do atendimento",
        "Teste como se fosse um cliente antes de colocar no ar",
      ],
    },
    agents: {
      title: "Agentes de IA",
      what: "Assistentes virtuais que entendem texto livre e respondem com base em documentos e orientações da empresa — por exemplo, dúvidas frequentes ou recepção inicial.",
      steps: [
        "Configure o assistente e o tom de resposta",
        "Anexe PDFs, textos e links que ele deve consultar",
        "Em Ciclo de vida de cada função do agente, defina transferências (para chatbot, humano ou outro agente) e mudanças de status",
        "Acompanhe se as respostas estão satisfazendo os clientes",
      ],
      tips: [
        "Comece com um caso claro — só FAQ ou só recepção — antes de expandir.",
        "Para transferir para um chatbot, use a fase Escalonamento ou Falha com destino chatbot.",
        "Na venda de passagem, gratuidade é a categoria do passageiro (idoso, estudante ou pessoa com deficiência). No chat, o agente pede os dados do benefício, como data de nascimento e, quando a regra exige, a renda. No formulário do WhatsApp (Flow), ligue ou desligue as gratuidades ao publicar o Flow no canal. Se mudar essa opção depois, publique o Flow de passagens novamente.",
      ],
    },
    positions: {
      title: "Cargos e permissões",
      what: "Define o que cada função pode ver e fazer: atender, configurar, ver relatórios, convidar pessoas etc. Para alguém ver só as próprias solicitações, marque Bloquear outros no cargo, na área de Atendimento. A opção esconde solicitações de outros atendentes. Bloquear fila esconde a fila sem responsável. O master do workspace não é limitado por essas opções.",
      steps: [
        "Crie cargos alinhados às funções da sua empresa",
        "Marque o que cada cargo pode acessar",
        "Se a pessoa não pode ver solicitações de colegas, marque Bloquear outros",
        "Atribua o cargo certo a cada usuário",
      ],
      tips: ["Meu dia e o filtro Minhas solicitações só mudam a visão daquela tela. Quem não tem Bloquear outros no cargo pode tirar o filtro e ver as solicitações dos colegas."],
    },
    channels: {
      title: "Canais",
      what:
        "Conecte os meios pelos quais clientes falam com você — WhatsApp oficial (Meta), WhatsApp por QR Code, Instagram, Facebook, e-mail, SMS, telefonia, loja online, portal do cliente e outros. Em cada canal você configura Roteamento padrão: novas solicitações podem ir para agente de IA, chatbot ou equipe humana (escolha uma opção por canal).",
      steps: [
        "Acesse Configurações → Canais e adicione o tipo de integração desejado",
        "Siga o passo a passo de conexão na tela (QR Code, Meta, validação de domínio etc.)",
        "Em Roteamento padrão, escolha agente de IA, chatbot ou usuários humanos",
        "Defina o Tipo de Atendimento padrão e salve",
        "Envie uma mensagem de teste para confirmar que funciona",
      ],
      tips: [
        "Para atendimento automático com IA no WhatsApp: crie o agente em Agentes de IA antes e selecione-o em Passar por agente de IA no canal.",
        "Só libere para a equipe depois de testar — evita surpresas no meio do atendimento.",
      ],
    },
    integrations: {
      title: "Integrações",
      what: "Liga o Xpro4 a outros serviços que sua empresa já usa — por exemplo, sistemas de passagem rodoviária ou ferramentas parceiras.",
      steps: [
        "Cadastre a integração indicada",
        "Preencha os dados solicitados e teste a conexão",
        "Acompanhe se continua funcionando ao longo do tempo",
      ],
    },
    workspace_i18n: {
      title: "Idiomas",
      what: "Personalize textos que clientes ou equipe veem em outros idiomas, quando sua operação é multilíngue.",
      steps: [
        "Escolha o idioma a editar",
        "Ajuste os textos que precisam de tradução",
        "Confira nas telas principais se ficou natural",
      ],
    },
    types: {
      title: "Tipos",
      what: "Classificações para organizar atendimentos — por assunto, departamento ou motivo do contato. Facilita busca, relatórios e respostas automáticas.",
      steps: [
        "Crie categorias e subcategorias que façam sentido para sua operação",
        "Defina padrões por canal, se aplicável",
        "Use nos atendimentos e automações do dia a dia",
      ],
    },
    categories: {
      title: "Categorias",
      what: "Agrupa produtos ou conteúdos em pastas — por exemplo, \"Eletrônicos\", \"Promoções\" — para loja e catálogo ficarem organizados.",
      steps: [
        "Crie as categorias",
        "Organize em níveis, se precisar de subpastas",
        "Vincule produtos e conteúdos a cada categoria",
      ],
    },
    automation_rules: {
      title: "Regras de automação",
      what: "Faz coisas sozinhas quando algo acontece — avisar alguém, mudar status, encaminhar conversa — sem precisar clicar manualmente toda vez. Cada regra tem um evento e uma ou mais ações; a mesma ação serve em vários eventos. No Web Chat há eventos de sessão e mensagem, além do prazo “cliente sem retorno após atendimento”, combináveis com convite por WhatsApp, mensagem no chat, alteração de status e os demais filtros. No e-mail, o nome de cada produto do pedido usa a variável {{item.nome}}, o código usa {{item.sku}} e a quantidade usa {{item.quantidade}}, dentro da repetição de itens que a tela cria ao inserir a variável.",
      steps: [
        "Descreva a condição (\"quando…\") e a ação (\"fazer…\")",
        "Teste em um caso real ou simulado",
        "Ative e observe se está ajudando de verdade",
      ],
    },
    antifraud_methods: {
      title: "Antifraude",
      what: "Conecta serviços que analisam risco em pagamentos ou pedidos, ajudando a reduzir fraudes conforme políticas da empresa.",
      steps: [
        "Cadastre o serviço de antifraude utilizado",
        "Informe os dados de acesso fornecidos pelo parceiro",
        "Alinhe com o time o que fazer em cada tipo de resultado",
      ],
    },
    payment_methods: {
      title: "Formas de pagamento",
      what: "Define como clientes podem pagar — PIX, cartão, boleto, dinheiro na retirada etc. — e quais estão ativas no momento.",
      steps: [
        "Cadastre cada forma aceita pela empresa",
        "Ative ou desative conforme a operação",
        "Revise se os status de pagamento batem com o que o time de atendimento espera",
      ],
    },
    delivery_methods: {
      title: "Formas de entrega",
      what: "Opções de frete, retirada na loja, transportadora ou combinações que sua empresa oferece, com prazos e regras por região.",
      steps: [
        "Cadastre cada forma de entrega",
        "Defina regiões, prazos e valores quando couber",
        "Simule um pedido para ver se o cliente vê as opções certas",
      ],
    },
    awareness_stages: {
      title: "Etapas dos níveis de consciência",
      what: "Personaliza as colunas do quadro de níveis de consciência — os nomes e a ordem em que seu time trabalha o funil.",
      steps: [
        "Crie ou renomeie as etapas",
        "Ordene da forma que a equipe combina",
        "Explique ao time quando mover um card de coluna",
      ],
    },
    coupons: {
      title: "Cupons",
      what: "Descontos promocionais com código, validade e regras de uso — para campanhas e vendas.",
      steps: [
        "Crie o cupom e o valor ou percentual de desconto",
        "Defina validade e limites de uso",
        "Acompanhe quantas vezes foi utilizado",
      ],
    },
    banners: {
      title: "Banners",
      what: "Imagens de destaque na vitrine ou site — promoções, avisos ou campanhas visuais com período de exibição. Publicar o banner não cria um filtro novo de produtos.",
      steps: [
        "Envie ou edite a imagem do banner",
        "Defina quando começa e termina de aparecer",
        "Se o clique deve abrir um sortimento, aponte o destino para uma categoria ou página que já liste esses produtos",
        "Publique e confira na vitrine se ficou como esperado",
      ],
    },
    contents: {
      title: "Conteúdos",
      what: "Páginas, textos e materiais auxiliares — políticas, treinamentos internos, landing pages — que a empresa publica no sistema.",
      steps: [
        "Crie ou edite o conteúdo",
        "Publique quando estiver pronto ou arquive se não for mais usar",
        "Revise links e textos para não confundir clientes ou equipe",
      ],
    },
    paid_ads: {
      title: "Anúncios pagos",
      what: "Acompanhe campanhas de Google, Meta ou outras plataformas de anúncio conectadas, vendo resultados importados em um só lugar.",
      steps: [
        "Conecte a conta de anúncios",
        "Confira métricas como cliques e investimento",
        "Use os números para decidir ajustes na campanha",
      ],
    },
    client_tags: {
      title: "Tags de clientes",
      what: "Etiquetas coloridas ou nomeadas para marcar clientes — VIP, inadimplente, região, interesse — e filtrar depois com facilidade.",
      steps: [
        "Crie as etiquetas que fazem sentido para sua operação",
        "Aplique nos cadastros de clientes",
        "Use em buscas e relatórios",
      ],
    },
    cities: {
      title: "Cidades (passageiros)",
      what: "Para empresas de transporte: lista de cidades atendidas em vendas de passagem, com origem, destino e disponibilidade.",
      steps: [
        "Cadastre as cidades da operação",
        "Associe trechos e rotas, se aplicável",
        "Teste uma busca de passagem como se fosse cliente",
      ],
    },
  },
  topbar: {
    notifications: {
      title: "Notificações",
      what: "O sino avisa sobre conversas novas, tarefas e outros alertas — sem precisar ficar atualizando a tela o tempo todo.",
      steps: [
        "Clique no sino quando aparecer um aviso",
        "Abra a notificação para ir direto ao assunto",
        "Volte ao que estava fazendo depois de resolver",
      ],
      tips: ["Se puder, ative som ou aviso na área de trabalho para não perder mensagens urgentes."],
    },
    themes: {
      title: "Aparência",
      what: "Escolha tema claro ou escuro (e variações) para trabalhar com mais conforto visual.",
      steps: [
        "Clique no ícone de aparência",
        "Escolha a opção que preferir",
        "A mudança vale na hora para todo o sistema",
      ],
    },
    platform_ai: {
      title: "Assistente da plataforma",
      what: "Tire dúvidas sobre como usar o Xpro4: peça explicações sobre menus, telas ou rotinas e receba orientação na hora.",
      steps: [
        "Clique no ícone de assistente",
        "Escreva sua dúvida com suas palavras",
        "Siga a orientação e teste na prática",
      ],
      tips: ["Mencione o nome do menu — \"canais\", \"clientes\", \"pagamento\" — para respostas mais certeiras."],
    },
    profile_menu: {
      title: "Menu da sua foto",
      what: "Atalhos pessoais: seu perfil, ajuda, tarefas, plano da empresa (se você tiver acesso) e sair do sistema.",
      steps: [
        "Clique na sua foto no canto superior direito",
        "Escolha o que precisa",
        "Conclua e volte ao trabalho",
      ],
    },
    help_training: {
      title: "Ajuda e Treinamento",
      what: "Atalho para materiais da sua empresa, tour passo a passo e esta Central de Ajuda. Veja também a pergunta \"Onde encontro ajuda?\" na aba Perguntas frequentes.",
      steps: [
        "Abra pelo menu da sua foto",
        "Leia treinamentos ou converse com o assistente de treinamento, se houver",
        "Use Guia completo ou Tour guiado conforme preferir",
      ],
    },
    platform_console: {
      title: "Console da plataforma",
      what: "Atalho para a área administrativa da Xpro — contas de empresas clientes, catálogo, governança e ferramentas internas. Só aparece para perfis autorizados.",
      steps: [
        "Abra pelo menu da sua foto",
        "Escolha a seção que precisa no console",
        "Conclua a tarefa administrativa e volte à conta da empresa, se necessário",
      ],
    },
    partner_console: {
      title: "Portal do parceiro",
      what: "Atalho para representantes e revendas gerenciarem clientes vinculados, equipe e precificação.",
      steps: [
        "Abra pelo menu da sua foto",
        "Acompanhe empresas clientes, presença ou cadastros conforme sua função",
      ],
    },
  },
  platform: {
    overview: {
      title: "Console da plataforma",
      what: "Área administrativa da Xvision para quem entra na sessão do console, não com o cargo do workspace. Cada pessoa vê só as áreas liberadas: Workspaces, Oportunidades, Insights, Dashboard, Uso do produto, Passagens, Presença, Segmentos, Governança, Catálogo e operações, Templates de ChatBot, Ações pendentes, Erros da plataforma, Instâncias, Financeiro e Ask interno.",
      steps: [
        "Acesse pelo menu da sua foto → Console da plataforma, já na sessão do console",
        "Escolha a seção desejada no menu lateral",
        "Faça a alteração ou consulta e confirme antes de sair",
      ],
      tips: [
        "Estar logado no workspace no mesmo navegador não abre o console.",
        "Use com cuidado: mudanças aqui podem afetar várias empresas clientes.",
      ],
    },
    ask_interno: {
      title: "Ask interno",
      what: "O Ask interno responde dúvidas de funcionamento para o time da Xvision que atende clientes. Só abre na sessão do console, para quem tem essa área liberada. Não mostra senha, arquivo, rota interna nem identificador de sistema. Limpar o cache não concede a permissão.",
      steps: [
        "Entre pelo login do console da plataforma",
        "Abra Ask interno",
        "Pergunte o fluxo da tela. Se a base não cobrir o assunto, a resposta diz que não encontrou — não invente um botão",
      ],
      tips: ["Se aparecer falta de permissão, alguém que administra os acessos do console precisa liberar a área Ask interno. O assistente dos clientes, dentro do workspace, é outro recurso."],
    },
    governance: {
      title: "Governança e portal do representante",
      what: "Não existe um interruptor chamado portal do afiliado dentro do workspace. O portal do cliente é um canal do workspace mais um convite por e-mail. O portal do representante é cadastrado na Governança do console, pela Xvision, que vincula os workspaces da carteira.",
      steps: [
        "Para o portal do cliente, confirme o canal em Configurações, Canais, e envie o convite em Clientes",
        "Para o representante, use Governança no console e vincule a carteira",
      ],
    },
    integrations: {
      title: "Integrações no console",
      what: "A lista de workspaces do console não tem uma coluna que filtre quem usa uma integração, por exemplo a RJ. Abra o workspace e confira Canais e as integrações daquele ambiente. O que uma solicitação trocou com um serviço externo fica na linha do tempo, filtro Logs de API, e não vira PDF.",
      steps: [
        "Abra o workspace",
        "Confira canais e integrações configurados ali",
        "Na solicitação, use o filtro Logs de API da linha do tempo para ver a requisição e a resposta daquele atendimento",
      ],
    },
  },
  partner: {
    overview: {
      title: "Portal do parceiro",
      what: "Painel do representante/revenda para acompanhar empresas clientes vinculadas, equipe, precificação e novos cadastros.",
      steps: [
        "Entre com usuário de parceiro ou use o atalho no menu do perfil",
        "Revise empresas clientes e indicadores na visão geral",
        "Cadastre novos clientes ou ajuste equipe quando necessário",
      ],
    },
  },
};

const guideSegmentOverrides = {
  [WorkspaceSegments.PassengerTransport]: {
    main: {
      dashboard: {
        what: "O Dashboard reúne indicadores do atendimento, clientes, vendas de passagens e pesquisas. No transporte rodoviário, a aba Passagens substitui Produtos.",
        steps: [
          "Selecione as datas que quer analisar",
          "Leia os números principais em cada card",
          "Use a aba Passagens para bilhetes, rotas e vendas do período",
        ],
      },
      products: {
        title: "Trechos",
        what: "Cadastro de trechos e rotas de passagem — origem, destino e regras comerciais usadas na venda de bilhetes.",
        steps: [
          "Cadastre ou edite trechos disponíveis",
          "Revise preços, horários e restrições",
          "Mantenha alinhado com integrações de passagem, se houver",
        ],
        tips: ["Trechos bem cadastrados evitam erro na venda dentro do atendimento."],
      },
      chat: {
        tips: [
          "No transporte rodoviário, durante a conversa pode haver atalho para venda de passagem — use quando o cliente quiser comprar.",
        ],
      },
    },
    settings: {
      integrations: {
        what: "Conecta o sistema a parceiros externos — em especial integrações de passagem rodoviária e telefonia com atendimento automático, quando sua operação usa.",
        steps: [
          "Cadastre a integração indicada pelo suporte ou parceiro",
          "Preencha credenciais e teste a conexão",
          "Valide uma consulta e uma venda de teste antes de operar",
        ],
      },
    },
  },
  [WorkspaceSegments.AutoParts]: {
    main: {
      products: {
        what: "Catálogo de peças, acessórios e itens do balcão — com preço, estoque e referências para atendimento e vendas.",
        tips: ["Mantenha códigos e descrições padronizados para facilitar busca no balcão."],
      },
    },
  },
};

export function resolveGuideContent(section, key, segment) {
  const base = guideContentByKey[section]?.[key];
  if (!base) return null;
  const patch = guideSegmentOverrides[segment]?.[section]?.[key];
  if (!patch) return base;
  return {
    ...base,
    ...patch,
    steps: patch.steps ?? base.steps,
    tips: patch.tips ?? base.tips,
  };
}
